$(function () {
    $("#NewsLocationFilter").on("change", function (e) {
        e.preventDefault();
        const data = $(this).serialize();
        const url = location.pathname + "?" + data;
        const toRefresh = [".blog-section-refresh"];
        loadAjaxContent(url, toRefresh);
    });

    $('.news-filter-item').on('change', function (e) {
        e.preventDefault();
        const locationFilter = $('#NewsLocationFilter').serialize();
        const industryFilter = $('#NewsIndustryFilter').serialize();
        const url = location.pathname + "?" + locationFilter + "&" +  industryFilter;
        const toRefresh = [".blog-section-refresh"];
        loadAjaxContent(url, toRefresh);
    });
});

function loadAjaxContent(url, toRefresh) {
    $.ajax({
        url: url,
        type: "GET",
        success: function (response) {
            let html = $(response);
            //Update page elements
            $.each(toRefresh, function (index, cl) {
                let element = html.find(cl);
                $(cl).replaceWith(element);
            });

            history.pushState(null, null, url);
        },
        error: function () {
            //console.error();
        },
    });
}
